export function Nav() {
  return (
    <nav className="nav" aria-label="Dashboard sections">
      <span className="nav-brand">FEMM · IFSD Research</span>
      <a href="#overview">Overview</a>
      <a href="#demographics">Demographics</a>
      <a href="#tiers">Tiers &amp; Scores</a>
      <a href="#signals">Hormone Signals</a>
      <a href="#domains">Domain Analysis</a>
      <a href="#investigations">Investigations</a>
      <a href="#diagnoses">Diagnoses</a>
      <a href="#cycle">Cycle Health</a>
      <a href="#insights">Research Insights</a>
      <a href="#timeline">Timeline</a>
      <a href="#triage">Triage</a>
    </nav>
  )
}
